import { TableCell, Stack, Typography, Chip } from '@mui/material';

export default function TitleCell({ title, tags }) {
  const list = Array.isArray(tags) ? tags.filter(Boolean) : [];

  return (
    <TableCell sx={{ maxWidth: 320 }}>
      <Stack spacing={0.75}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          title={title}
        >
          {title}
        </Typography>

        {list.length > 0 && (
          <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
            {list.slice(0, 6).map((t, idx) => (
              <Chip
                key={`${t}-${idx}`}
                label={t}
                size="small"
                variant="outlined"
                sx={{
                  pointerEvents: 'none', // ✅ không tương tác
                  userSelect: 'none',
                  height: 22,
                }}
              />
            ))}

            {list.length > 6 && (
              <Chip
                label={`+${list.length - 6}`}
                size="small"
                variant="outlined"
                sx={{ pointerEvents: 'none', userSelect: 'none', height: 22 }}
              />
            )}
          </Stack>
        )}
      </Stack>
    </TableCell>
  );
}